// extracted by mini-css-extract-plugin
export default {"button":"styles_button__+HsLH","overlayActive":"styles_overlayActive__n6R3O"};